<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
      <a href="/" class="logo">
        <!-- mini logo for sidebar mini 40x50 pixels -->
        <!-- logo for regular state and mobile devices -->
        <div class="logo-lg">
<!--          <span>蔡同德渠道查询</span>-->
          <span>农工商长征医药渠道查询</span>
<!--          <span>上海上虹医药渠道查询</span>-->
        </div>
      </a>

      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!-- Messages-->
            <li class="dropdown messages-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" @click="myMessagesInvoke">
                <i class="fa fa-envelope-o"></i>
                <span class="label label-success">{{ messagesCount }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ messagesCount }} message(s)</li>
                <li v-if="messagesCount > 0" v-for="item in myMessages">
                  <!-- inner menu: contains the messages -->
                  <ul class="menu">
                    <li><!-- start message -->
                      <a href="javascript:;" @click="subItemClick(item)">
                        <!-- Message title and timestamp -->
                        <h4>
                          {{item.subject}}
                          <!-- <small><i class="fa fa-clock-o"></i> 5 mins</small> -->
                        </h4>
                        <!-- The message -->
                        <!-- <p>Why not consider this a test message?</p> -->
                        <p>{{item.body}}</p>
                      </a>
                    </li>
                    <!-- end message -->
                  </ul>
                  <!-- /.menu -->
                </li>
                <li class="footer" v-if="messagesCount > 0"><a href="javascript:;">See All Messages</a></li>
              </ul>
            </li>
            <!-- /.messages-menu -->

            <!-- Notifications Menu -->
            <li class="dropdown notifications-menu" v-show="false">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-bell-o"></i>
                <span class="label label-warning">{{ userInfo.notifications | count }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.notifications | count }} notification(s)</li>
                <li v-if="userInfo.notifications.length > 0">
                  <!-- Inner Menu: contains the notifications -->
                  <ul class="menu">
                    <li><!-- start notification -->
                      <a href="javascript:;">
                        <i class="fa fa-users text-aqua"></i> 5 new members joined today
                      </a>
                    </li>
                    <!-- end notification -->
                  </ul>
                </li>
                <li class="footer" v-if="userInfo.notifications.length > 0"><a href="javascript:;">View all</a></li>
              </ul>
            </li>

            <!-- Tasks Menu -->
            <li class="dropdown tasks-menu" v-show="false">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-flag-o"></i>
                <span class="label label-danger">{{ userInfo.tasks | count }} </span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.tasks | count }} task(s)</li>
                <li v-if="userInfo.tasks.length > 0">
                  <!-- Inner menu: contains the tasks -->
                  <ul class="menu">
                    <li><!-- Task item -->
                      <a href="javascript:;">
                        <!-- Task title and progress text -->
                        <h3>
                          Design some buttons
                          <small class="pull-right">20%</small>
                        </h3>
                        <!-- The progress bar -->
                        <div class="progress xs">
                          <!-- Change the css width attribute to simulate progress -->
                          <div class="progress-bar progress-bar-aqua"
                               style="width: 20%"
                               role="progressbar"
                               aria-valuenow="20"
                               aria-valuemin="0"
                               aria-valuemax="100">
                            <span class="sr-only">20% Complete</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <!-- end task item -->
                  </ul>
                </li>
                <li class="footer" v-if="userInfo.tasks.length > 0">
                  <a href="javascript:;">View all tasks</a>
                </li>
              </ul>
            </li>

            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <img src="../../static/img/avatar5.png" class="user-image" alt="User Image">
                <span class="hidden-xs">{{username}}</span>
              </a>
              <ul class="dropdown-menu">
                <!-- User image -->
                <li class="user-header">
                  <img src="../../static/img/avatar5.png" class="img-circle" alt="User Image">
                  <p>
                    {{username}}
                  </p>
                  <p>
                    {{roles}}
                  </p>
                </li>
                <!-- Menu Footer-->
                <li class="user-footer">
                  <div class="pull-left">
                    <a href="/manage/profile" class="btn btn-default btn-flat">用户信息</a>
                  </div>
                  <div class="pull-right">
                    <a class="btn btn-default btn-flat" @click="logout()">退出</a>
                  </div>
                </li>
              </ul>
            </li>
            <!--  <li>
               <a href="#" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>
             </li> -->
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName"
             :picture-url="demo.avatar"/>

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{$route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small>
        </h1>
        <ol class="breadcrumb">
          <li><a href="javascript:;"><i class="fa fa-home"></i>首页</a></li>
          <li class="active">{{$route.name.toUpperCase()}}</li>
        </ol>
      </section>

      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <!-- <footer class="main-footer">
      <strong>Copyright &copy; {{year}} <a >DTP</a>.</strong> All rights reserved.
    </footer> -->

    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Create the tabs -->
      <ul class="nav nav-tabs nav-justified control-sidebar-tabs">
        <li><a href="#control-sidebar-home-tab" data-toggle="tab"><i class="fa fa-home"></i></a></li>
        <li><a href="#control-sidebar-settings-tab" data-toggle="tab"><i class="fa fa-gears"></i></a></li>
      </ul>
      <!-- Tab panes -->
      <div class="tab-content">
        <!-- Home tab content -->
        <div class="tab-pane" id="control-sidebar-home-tab">
          <h3 class="control-sidebar-heading">Recent Activity</h3>
          <ul class="control-sidebar-menu">
            <li>
              <a href="javascript:void(0)">
                <i class="menu-icon fa fa-birthday-cake bg-red"></i>

                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">Langdon's Birthday</h4>

                  <p>Will be 23 on April 24th</p>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <i class="menu-icon fa fa-user bg-yellow"></i>

                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">Frodo Updated His Profile</h4>

                  <p>New phone +1(800)555-1234</p>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <i class="menu-icon fa fa-envelope-o bg-light-blue"></i>

                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">Nora Joined Mailing List</h4>

                  <p>nora@example.com</p>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <i class="menu-icon fa fa-file-code-o bg-green"></i>

                <div class="menu-info">
                  <h4 class="control-sidebar-subheading">Cron Job 254 Executed</h4>

                  <p>Execution time 5 seconds</p>
                </div>
              </a>
            </li>
          </ul>
          <!-- /.control-sidebar-menu -->

          <h3 class="control-sidebar-heading">Tasks Progress</h3>
          <ul class="control-sidebar-menu">
            <li>
              <a href="javascript:void(0)">
                <h4 class="control-sidebar-subheading">
                  Custom Template Design
                  <span class="label label-danger pull-right">70%</span>
                </h4>

                <div class="progress progress-xxs">
                  <div class="progress-bar progress-bar-danger" style="width: 70%"></div>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <h4 class="control-sidebar-subheading">
                  Update Resume
                  <span class="label label-success pull-right">95%</span>
                </h4>

                <div class="progress progress-xxs">
                  <div class="progress-bar progress-bar-success" style="width: 95%"></div>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <h4 class="control-sidebar-subheading">
                  Laravel Integration
                  <span class="label label-warning pull-right">50%</span>
                </h4>

                <div class="progress progress-xxs">
                  <div class="progress-bar progress-bar-warning" style="width: 50%"></div>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)">
                <h4 class="control-sidebar-subheading">
                  Back End Framework
                  <span class="label label-primary pull-right">68%</span>
                </h4>

                <div class="progress progress-xxs">
                  <div class="progress-bar progress-bar-primary" style="width: 68%"></div>
                </div>
              </a>
            </li>
          </ul>
          <!-- /.control-sidebar-menu -->

        </div>
        <!-- /.tab-pane -->
        <!-- Stats tab content -->
        <div class="tab-pane" id="control-sidebar-stats-tab">Stats Tab Content</div>
        <!-- /.tab-pane -->
        <!-- Settings tab content -->
        <div class="tab-pane" id="control-sidebar-settings-tab">
          <form method="post">
            <h3 class="control-sidebar-heading">General Settings</h3>

            <div class="form-group">
              <label class="control-sidebar-subheading">
                Report panel usage
                <input type="checkbox" class="pull-right" checked>
              </label>

              <p>
                Some information about this general settings option
              </p>
            </div>
            <!-- /.form-group -->

            <div class="form-group">
              <label class="control-sidebar-subheading">
                Allow mail redirect
                <input type="checkbox" class="pull-right" checked>
              </label>

              <p>
                Other sets of options are available
              </p>
            </div>
            <!-- /.form-group -->

            <div class="form-group">
              <label class="control-sidebar-subheading">
                Expose author name in posts
                <input type="checkbox" class="pull-right" checked>
              </label>

              <p>
                Allow the user to show his name in blog posts
              </p>
            </div>
            <!-- /.form-group -->

            <h3 class="control-sidebar-heading">Chat Settings</h3>

            <div class="form-group">
              <label class="control-sidebar-subheading">
                Show me as online
                <input type="checkbox" class="pull-right" checked>
              </label>
            </div>
            <!-- /.form-group -->

            <div class="form-group">
              <label class="control-sidebar-subheading">
                Turn off notifications
                <input type="checkbox" class="pull-right">
              </label>
            </div>
            <!-- /.form-group -->

            <div class="form-group">
              <label class="control-sidebar-subheading">
                Delete chat history
                <a href="javascript:void(0)" class="text-red pull-right"><i class="fa fa-trash-o"></i></a>
              </label>
            </div>
            <!-- /.form-group -->
          </form>
        </div>
        <!-- /.tab-pane -->
      </div>
    </aside>
    <!-- /.control-sidebar -->
    <!-- Add the sidebar's background. This div must be placed
         immediately after the control sidebar -->
    <div class="control-sidebar-bg"></div>
  </div>
  <!-- ./wrapper -->
</template>

<script>
  import faker from 'faker'
  import {mapState} from 'vuex'
  import config from '../config'
  import Sidebar from './Sidebar'
  import 'hideseek'

  import axios from 'axios';
  import {baseURL, serverURL, webapi} from '../api/api'

  import SockJS from "../../static/js/sockjs.min.js";


  export default {
    name: 'Dash',

    components: {
      Sidebar
    },
    data() {
      return {
        messagesCount: 0,
        myMessages: [],
        username: '',
        roles: window.localStorage.getItem('roles') == "ROLE_ADMIN" && window.localStorage.getItem('user') == "admin" ? '管理员' : window.localStorage.getItem('roles') == "ROLE_ADMIN" && window.localStorage.getItem('user') != "admin" ? '操作员' : window.localStorage.getItem('roles') == "ROLE_USER" ? '用户' : "未知",
        year: new Date().getFullYear(),
        classes: {
          fixed_layout: config.fixedLayout,
          hide_logo: config.hideLogoOnMobile
        },
        error: ''
      }
    },
    computed: {
      ...mapState([
        'userInfo'
      ]),
      demo() {
        return {
          displayName: faker.name.findName(),
          avatar: faker.image.avatar(),
          email: faker.internet.email(),
          randomCard: faker.helpers.createCard()
        }
      }
    },
    methods: {
      getCommonName() {
        let para = {username: window.localStorage.getItem('user')};
        webapi.post('/user/getCommonName', para).then((res) => {
          this.username = res.data.commonName
        }).catch(error => {
        })
      },
      changeloading() {
        this.$store.commit('TOGGLE_SEARCHING')
      },
      logout() {
        var vm = this;
        //alert(window.localStorage.getItem('token'));
        vm.$confirm('确认登出吗?', '提示', {
          type: 'warning'
        }).then(() => {
          webapi.post('/logout').then((res) => {

            window.localStorage.removeItem('user')
            window.localStorage.removeItem('token')
            window.localStorage.removeItem('roles')

            vm.$message({
              message: '登出成功',
              type: 'success'
            });
            vm.$router.push("/");
          });
        }).catch((error) => {
          vm.$message.error(error.response.data['message']);
        });
      },
      myMessagesCount() {
        console.log("baseURL========", baseURL)
        let webapi = axios.create({
          baseURL: baseURL
          // ,
          // headers: {
          //   Authorization: 'Bearer '+window.localStorage.getItem("token")
          // }
        })

        let para = {
          params: {}
        };

        // webapi.get('/message/myMessagesCount',para).then((response) => {
        //    // console.log("============response",response.data)
        //    this.messagesCount = response.data.count;
        // }).catch(function (error) {
        //   // console.log(error.response.data['message']);
        //   // this.$message.error('服务器连接失败,请联系管理员!');
        //   this.$message.error(error.response.data['message']);
        // });
      },
      myMessagesInvoke() {
        let para = {
          params: {}
        };


        // webapi.get('/message/myMessages',para).then((response) => {
        //    // console.log("============response",response.data)
        //    this.myMessages = response.data;
        //    // this.messagesCount = response.data.count;
        // }).catch(function (error) {
        //   // console.log(error.response.data['message']);
        //   // this.$message.error('服务器连接失败,请联系管理员!');
        //   this.$message.error(error.response.data['message']);
        // });
      },
      subItemClick(item) {
        let para = {
          id: item.id
        };

        // return;

        // webapi.post('/message/acknowledgeMessage',para).then((response) => {
        //    // console.log("============response",response.data)
        //    this.$router.push({ path: '/manage/OrderTable' });
        //    this.myMessagesCount()
        //    this.myMessagesInvoke()
        //    // this.myMessages = response.data;
        //    // this.messagesCount = response.data.count;
        // }).catch(function (error) {
        //   // console.log(error.response.data['message']);
        //   // this.$message.error('服务器连接失败,请联系管理员!');
        //   this.$message.error(error.response.data['message']);
        // });
      },

      notify(arr) {
        var _this = this;
        let _title = arr[1];
        let _message = arr[2];
        let _id = parseInt(arr[0])
        if (arr.length == 0) return;
        // this.$notify.success({
        //   title: _title,
        //   message: _message,
        //   // offset: 200,
        //   duration:8000,
        //   onClick:function(){
        //     _this.$router.push({ path: '/manage/OrderTable' });
        //     // _this.myMessagesInvoke();
        //     _this.subItemClick({id:_id});
        //     this.close();
        //   }
        // });

      },
      websocketTest() {
        // var socket = new SockJS("${createLink(uri: '/stomp')}");
        // var sjsc = require('sockjs-client');

        var sockjs = new SockJS(serverURL + "/stomp")
        // var sockjs = new SockJS("http://localhost:8080/api/message/sendMessage")
        var client = Stomp.over(sockjs);
        // var client = Stomp.client("ws://localhost:8080/stomp");
        // var client = Stomp.client("ws://localhost:8080/topic/msg");
        // var client = sjsc.create("http://localhost:8080");
        // var client = Stomp.over('ws://localhost:8080');
        //var headers = {};
        //headers['Authorization'] = 'Bearer 5ob1c838jea8v73o6cq26m8rdl5dgbm6';
        //client.connect(headers, function() {

        var username = window.localStorage.getItem('user');

        console.log('topic: ' + "/topic/msg/" + username)

        let _this = this;
        client.connect({}, function () {
          client.subscribe("/topic/msg/" + username, function (message) {
            // console.log("message=======",message)
            let str = message.body;
            let arr = str.split("$");
            // console.log("=====str=====",str.split("$"))
            // _this.$message({
            //   message: '您有一条新的订单信息!请点击查看!',
            //   type: 'info',
            //   duration:5000
            // });

            _this.notify(arr);

            _this.myMessagesCount();
          });
        });
      }
    },
    mounted() {
      this.$nextTick(function () {
        this.myMessagesCount();
        this.websocketTest();
        // this.getCommonName();
      })

    }
  }
</script>

<style lang="scss">
  .wrapper.fixed_layout {
    .main-header {
      position: fixed;
      width: 100%;
    }

    .content-wrapper {
      padding-top: 50px;
    }

    .main-sidebar {
      position: fixed;
      height: 100vh;
    }
  }

  .wrapper.hide_logo {
    @media (max-width: 767px) {
      .main-header .logo {
        display: none;
      }
    }
  }

  .logo-mini, .logo-lg {
    text-align: left;

    img {
      padding: .4em;
    }
  }

  .logo-lg {
    img {
      display: -webkit-inline-box;
      width: 25%;
    }
  }

  .user-panel {
    height: 4em;
  }

  hr.visible-xs-block {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.17);
    height: 1px;
    border-color: transparent;
  }

  .content-header h1 {
    margin: 0;
    font-size: 20px;
  }

  .navbar-nav > .user-menu > .dropdown-menu > li.user-header > p, .navbar-nav > .user-menu > .dropdown-menu > .user-footer .btn-default {
    font-size: 12px;
  }

  .user-panel > .image > img {
    max-width: 35px;
  }
</style>



// WEBPACK FOOTER //
// Dash.vue?830f6406